export default __webpack_public_path__ + "static/media/testamonialAvatar1.219a2265.jpg";